import { Div, Collection } from "@tblabs/truffle";
import { Field } from "../../../Models/Description/Field";
import { DescriptionFieldPrinter } from "../DescriptionFieldPrinter";


export class DescriptionPrinter extends Div
{
    constructor(fields: Field[] | Collection<Field>, fieldClass: string = "")
    {
        super();

        if (fields instanceof Collection)
        {
            this.Append(
                ...fields.Items.map(entry => new DescriptionFieldPrinter(entry).Class(fieldClass))
            );
        }
        else
        {
            this.Append(...fields.map(entry => new DescriptionFieldPrinter(entry).Class(fieldClass)));
        }
    }
}
